module.exports = __webpack_public_path__ + "static/media/flyer_placeholder.8e072426.svg";